import { render, staticRenderFns } from "./SBScrollContent.html?vue&type=template&id=1e2e9064&scoped=true&"
import script from "./SBScrollContent.ts?vue&type=script&lang=ts&"
export * from "./SBScrollContent.ts?vue&type=script&lang=ts&"
import style0 from "./SBScrollContent.css?vue&type=style&index=0&id=1e2e9064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2e9064",
  null
  
)

export default component.exports